import React from 'react';
import { OverflowWrapper } from 'app/components';
import { Pencil, Trash } from '@phosphor-icons/react';

const STATUS_MAPPING = {
  Rejected: 'error',
  Approved: 'primary-green',
};

export const COLUMN_CONFIG = [
  {
    'label': 'Requested Event URL',
    'path': 'url',
    'order': 1,
    'field': 'url',
    rowElement: ({ row }) => (
      <a className="underline underline-offset-4"
        target="_blank"
        rel="noreferrer"
        href={row?.url}><OverflowWrapper>{row?.url}</OverflowWrapper></a>
    ),
  },
  {
    'label': 'Type',
    'path': 'type',
    'order': 2,
    'field': 'type',
  },
  {
    'label': 'Requested Date',
    'path': 'createdAt',
    'order': 3,
    isDate: true,
    'field': 'createdAt',
  },
  {
    'label': 'Status',
    'path': 'status',
    'order': 4,
    isDate: true,
    'field': 'status',
    rowElement: ({ row }) => (
      <div className={`label-16 text-${STATUS_MAPPING[row?.status]}`}>{row?.status || 'Pending'}</div>
    ),
  },
  {
    'label': '',
    'path': 'action_items',
    'order': 5,
    'field': 'action_items',
  },
];

export const ACTION_ITEMS = [
  { icon: <Pencil />, action: 'edit' },
  { icon: <Trash />, action: 'delete' },
];
